module.exports = __webpack_public_path__ + "static/media/Brackets.1248758d.svg";